import {BaseApi} from '@/common/api/BaseApi';
import {ApiProperties, ApiVersionProperties} from '@/types/common/api/api.types';

export class FileSystemApi {

  public static api({id, version = 'v1'}: ApiProperties = {}): string {
    return `${BaseApi.ROOT_URL}/api/${version}/file-system${id !== undefined ? `/${id}` : ''}`;
  }

  public static handle({version = 'v1'}: ApiVersionProperties = {}): string {
    return `${this.api({version})}/handle`;
  }

  public static removeMultipleFile({version = 'v1'}: ApiVersionProperties = {}): string {
    return `${this.api({version})}/remove-multiple-file`;
  }

  public static fileInfo({version = 'v1'}: ApiVersionProperties = {}): string {
    return `${this.api({version})}/info`;
  }

  public static fileName({version = 'v1'}: ApiVersionProperties = {}): string {
    return `${this.api({version})}/file-name`;
  }

  public static compress({version = 'v1'}: ApiVersionProperties = {}): string {
    return `${this.api({version})}/compress`;
  }

  public static rename({version = 'v1'}: ApiVersionProperties = {}): string {
    return `${this.api({version})}/rename`;
  }

  public static fileDetails({id, version = 'v1'}: ApiProperties = {}): string {
    return `${this.api({version})}/details/${id}`;
  }

  public static usage({id, version = 'v1'}: ApiProperties = {}): string {
    return `${this.api({version})}/usage/${id}`;
  }
}
